<template>
  <div class="h-dialogContainer h-nomargin">
    <div class="height-320 row m-b-10">
      <div class="col-sm-3 nopadding:last-child">
        <div class="h-borderBox height-320">
          <div class="h-borderBox-top">
            <ejs-textbox
              :placeholder='$t("Software.enterKeywordSearchDevice")'
              @keydown.enter.native="searchMethod"
              v-model="input"
            />
          </div>
          <ejs-grid ref="listNe" :dataSource="listdata" height="200">
            <e-columns>
              <e-column type="checkbox" width="10"></e-column>
              <e-column
                field="text"
                :headerText='$t("Software.td_neID")'
                width="80"
                clipMode="EllipsisWithTooltip"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="col-sm-9 nopadding:first-child">
        <div class="h-borderBox height-320" style="overflow-x: hidden;">
          <verlib-list ref="veblist" :update="false" :hasBorder="true"></verlib-list>
        </div>
      </div>
    </div>
    <div class="b-t row h-row-around-inputBox" />
    <div class="row">
      <div class="h-col-inputBox h-marginT28 col-sm-12 nopadding">
        <div class="col-sm-7 row nopadding">
          <div class="h-inputLit">{{$t('Software.td_executionTime')}}</div>
          <ejs-datetimepicker
            :locale="locale"
            :format="format"
            :timeFormat="timeFormat"
            v-model="timevalue"
          ></ejs-datetimepicker>
        </div>
      </div>
      <div class="h-col-inputBox col-sm-12" style="padding:0 0px;">
        <div class="col-sm-7">
          <div class="h-inputLit">{{$t('Software.updataOper')}}</div>
          <div v-for="(item,index) in udOperlist" :key="index" class="col-sm-3 nopadding">
            <ejs-checkbox :label="item.label" v-model="item.checked" />
          </div>
        </div>
      </div>
      <div class="h-col-inputBox col-sm-12 nopadding" style="padding:0 0px;">
        <div class="col-sm-1 row nopadding">
          <span class="icon hero-icon hero-icon-detailed" style="line-height: 21px;padding:0 10px;"></span>
        </div>
        <div class="col-sm-7 row">
          <div style="padding:0 10px;">{{$t('Software.caution')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VerlibList from "./VerlibList";
import TopoTree from "../topoconfig/TopoTree";
import { stringify } from "qs";
import { isNullOrUndefined } from "@syncfusion/ej2-base";
let Source = [];
Date.prototype.Format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  name: "version-task",
  props: ["showToast"],
  components: {
    VerlibList,
    TopoTree
  },
  data() {
    return {
      format: "yyyy-MM-dd HH:mm:ss",
      timeFormat: "HH:mm:ss",
      locale: localStorage.getItem("locale"),
      timevalue: new Date(),
      listdata: [],
      input: "",
      udOperlist: [
        {
          label: this.$t("Software.download"),
          value: "1",
          checked: false
        },
         {
             label: this.$t('Software.active'),
             value: '2',
             checked: false
         },
        //  {
        //      label: this.$t('Software.dataUpload'),
        //      value: '0',
        //      checked: false
        //  }
      ]
    };
  },
  methods: {
    _getNeTreeData() {
      this.listdata = [];
      this.$axios
        .post("/lte/ems/auth/findVMEquipmentListByAuth", [10009,10004])
        .then(response => {
          //5G更改只展示GNB设备
          const _nodeArray = response.data;
          const showData = [];
          const showPrimaryDatas = [];
          _nodeArray.forEach(_item => {
            const { id, name, equipmentIP, equipmentIPId, typeCode ,softwareVersion} = _item;
            let _dataItem={}
            if(typeCode==10009&&softwareVersion=="ssl"){
               _dataItem = {
              text: name,
              id: id,
              neType: typeCode,
              tooltip: equipmentIP,
              equipmentIPId: 0,
              linkSelect:softwareVersion
            };}else{
             _dataItem = {
              text: name,
              id: id,
              neType: typeCode,
              tooltip: equipmentIP,
              equipmentIPId: _item.EquipmentIP[0].id,
              linkSelect:softwareVersion

            };}
            showData.push(_dataItem);
          });
          this.listdata = showData;
          Source = showData;
        });
    },
    getUserId() {
      const principal = JSON.parse(sessionStorage.getItem("principal"));
      return principal ? principal.userId : "110";
    },
    updateVersion(callback) {
      const dateMax=new Date(this.timevalue).getTime()-new Date().getTime();
      if(dateMax>7*24*3600*1000){
        this.showToast("warning", `请选择7天内`);
        return;
      }
      const checkNodes = this.$refs.listNe.getSelectedRecords();
      const NeIdList = Array.from(checkNodes, x => {
        return x.id;
      });
      if (NeIdList.length == 0) {
        this.showToast("warning", `${this.$t("Software.selectDevice")}`);
        return;
      }
      if (NeIdList.length > 10) {
        this.showToast("warning", `${this.$t("Software.updateBSMax")}`);
        return;
      }
      const checkPkg = Array.from(this.$refs.veblist.getSelect(), x => {
        return x.pkgId;
      });
      if (checkPkg.length == 0) {
        this.showToast("warning", `${this.$t("Software.selectPkg")}`);
        return;
      }
      if (checkPkg.length > 1) {
        //tr069升级GNB，目前只支持一次升级一个升级包
        this.showToast("warning", `只选一个升级包`);
        return;
      }
            
      let config = {
        headers: {
          "Content-Type": "application/json"
        }
      };
      let params = {//4G设备dowload选中是下载升级包到设备侧；5G设备 download 选中走全升级流程
        isDownLoad: this.udOperlist[0].checked ? 1 : 0,
        isActive: this.udOperlist[1].checked ? 1:0,
        isUpLoad: this.udOperlist[1].checked ? 1:0,//tr069升级只留下载一个选项 (4G 5G兼容放开两个选项)
        //isActive: 0,
        //isUpLoad: 0,
        execTime: new Date(this.timevalue).Format("yyyy-MM-dd HH:mm:ss"),
        systemId: "1",
        isfilter: 0
      };
       if(params.isDownLoad === 0 && params.isActive === 0 && params.isUpLoad === 0){//tr069升级改造，只有一个选择(4G 5G 兼容 重新放开)
      //if (params.isDownLoad === 0) {
        //tr069升级改造，只有一个选择
        this.showToast("warning", `${this.$t("Software.selectOprType")}`);
        return;
      }

      this.$layer.confirm({
        msg: `${this.$t('DeployManagement.upgrageConfirm')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {

      const activeStatus="TRUE";
      const activateTime=new Date(this.timevalue).Format("yyyy-MM-ddTHH:mm:ss");
      const mml =
        "MOD SoftwareCtrl : ne= " +
        NeIdList[0] +
        " , activateEnable = "+activeStatus+", activateTime = " +
        activateTime +
        " ;";
      const data = {
        neId: NeIdList[0],
        cmd: mml,
        channelId: this.getUserId(),
        cmdType: 1
      };
      let equipmentIPId = "";
      let linkSelect = "";
      for (var i = 0; i < this.listdata.length; i++) {
        if (this.listdata[i].id == NeIdList[0]) {
          equipmentIPId = this.listdata[i].equipmentIPId;
          if (undefined==this.listdata[i].equipmentIPId||this.listdata[i].equipmentIPId ==0) {
         //tr069升级GNB，链路需为tr069
            this.showToast("warning", `此基站不支持升级`);
            return;
           }
           linkSelect = this.listdata[i].linkSelect;
        }
      }
      let para = {
        neIdList: NeIdList,
        pkgList: checkPkg,
        linkSelect:linkSelect
      };
      data.equipmentIpId = equipmentIPId;
      data.startTime = Date.now();
      data.executeTime = 0;
      data.exportMos = "";
      this.$loading.showLoadding(this.$t('Common.waiting'));
      if(linkSelect=="tr069"){
        if(params.isDownLoad === 0){
          this.showToast("warning", `tr069类型设备升级，下载操作必须选中`);
          this.$loading.hideLoadding(this.$t('Common.waiting'));
          return;
        }
      this.axios
        .post("/lte/ems/config/mml/asyncExeMML", data)
        .then(res => {
          //tr069先下发激活，成功后再下发下载升级操作
          console.log("async res= ", res);
          if (res.data.errorCode !== "SUCCESS") {
            this.$loading.hideLoadding();
          }
          if (res.data.errorCode == "SUCCESS") {
            //激活操作成功再触发升级
            this.axios
              .post(
                `/lte/ems/verupdate_new/updateVerAction?${stringify(params)}`,
                JSON.stringify(para),
                config
              )
              .then(response => {
                this.$loading.hideLoadding();
                console.log("update", response);
                callback();
                if (response.status == 200) {
                  if (response.data.errorCode == "SUCCESS") {
                    this.showToast(
                      "success",
                      `${this.$t("Common.tips.success")}`
                    );
                  } else {
                    this.showToast("error", response.data.errorString);
                  }
                } else {
                  this.showToast("error", `${this.$t("Common.tips.failure")}`);
                }
              });
          }
        })
        .catch(err => {
          console.error("async err= ", err);
        });}
        else if(linkSelect=="ssl"){
          this.axios.post(
                `/lte/ems/verupdate_new/updateVerAction?${stringify(params)}`,
                JSON.stringify(para),
                config
              )
              .then(response => {
                this.$loading.hideLoadding();
                console.log("update", response);
                callback();
                if (response.status == 200) {
                  if (response.data.errorCode == "SUCCESS") {
                    this.showToast(
                      "success",
                      `${this.$t("Common.tips.success")}`
                    );
                    console.log("update", response);
                  } else {
                    this.showToast("error", response.data.errorString);
                  }
                } else {
                  this.showToast("error", `${this.$t("Common.tips.failure")}`);
                }
              });
            }
          }
        }
      });
    },

    searchMethod() {
      if (this.input === "") {
        this.listdata = Source;
      } else {
        this.listdata = this.search(
          this.input,
          Source,
          this.$refs.listNe.getColumns()
        );
      }
    },
    search(input, source, columns, maparray) {
      var filterdata = source
        .filter(item => {
          let columntext = Array.from(columns, x => {
            return x.field;
          });
          let feildData = Array.from(columntext, x => {
            if (maparray && maparray.has(x)) {
              let value = maparray.get(x).get(item[x]);
              return isNullOrUndefined(value) ? "" : value;
            } else {
              return isNullOrUndefined(item[x]) ? "" : item[x] + "";
            }
          });
          let filres = false;
          feildData.forEach(item => {
            if (item.indexOf(input) > -1) {
              filres = true;
            }
          });
          return filres;
        })
        .map(item => {
          return item;
        });
      return filterdata;
    }
  }
};
</script>>
